export const version = "1.7.18";
export const channel = "release";
export const gitcommit = "unknown";
